<template>
  <div class="page_ changePwd_">
    <div class="form_con form_con1">
      <a-form @submit="handleChangeSubmit" :form="pwdForm">
        <!-- <a-form-item label="用户名">
          <a-input
            placeholder="请输入用户名"
            v-decorator="[
              'username',
              {
                rules: [{ required: true, message: '请输入用户名!' }],
              },
            ]"
          ></a-input>
        </a-form-item> -->
        <a-form-item
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          label="原始密码"
        >
          <a-input
            placeholder="请输入原始密码"
            v-decorator="[
              'oldPassWord',
              {
                rules: [{ required: true, message: '请输入原始密码!' }],
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          label="新密码"
        >
          <a-input
            placeholder="请输入新密码"
            v-decorator="[
              'newPassWord',
              {
                rules: [{ required: true, message: '请输入新密码!' }],
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          label="确认新密码"
        >
          <a-input
            placeholder="请确认新密码"
            v-decorator="[
              'passWord',
              {
                rules: [{ required: true, message: '请再次输入新密码!' }],
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item
          style="width:167px;height:42px;line-height:42px;margin:37px auto 0;display:block;"
        >
          <a-button
            type="primary"
            style="width:167px;height:42px;line-height:42px;"
            html-type="submit"
            >确定</a-button
          >
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.page_ {
  margin-top: 100px;
}
.form_con {
  // width: 320px;
  margin: 0 auto;
  .ant-form-item {
    display: block;
    margin-bottom: 15px;
    .ant-input {
      // width: 216px;
      height: 34px;
      line-height: 34px;
    }
    .ant-form-item-label {
      // width: 85px;
      text-align: right;
    }
  }
  .btn_send_code_ {
    position: absolute;
    top: -11px;
    right: 10px;
    cursor: pointer;
  }
}
</style>
<script>
import navbar from "../components/navbar";
import api from "@/utils/api";
import { setLogined, setToken, getUserInfo } from "@/utils/authorized";
export default {
  data() {
    document.title = "修改密码";
    return {
      labelCol: { span: 2 },
      wrapperCol: { span: 4 },
      pwdForm: this.$form.createForm(this),
      count: 0,
      submitDisabled: false,
      phone: "",
      phoneOrigin: "",
    };
  },
  components: {
    navbar,
  },
  mounted() {},
  methods: {
    handleChangeSubmit(e) {
      e && e.preventDefault();
      this.pwdForm.validateFields((error, values) => {
        if (!error) {
          console.log(values, "--->values");
          let data = {
            ...values,
            username: getUserInfo().userName,
          };
          if (values.passWord !== values.newPassWord) {
            this.$message.warning("两次输入的新密码不一致", 5);
          } else {
            this.changePwd(data);
          }
        }
      });
    },
    changePwd(data) {
      api
        .changeGDPassword(data)
        .then((res) => res.data)
        .then((data) => {
          if (data.returnCode == "00") {
            this.$message.success("修改成功", 5);
            this.$router.push({ name: "gd-login" });
          } else if (data.returnCode == "01") {
            this.$message.error(data.returnMsg, 5);
          }
        });
    },
  },
};
</script>
